(ns common.date-formats
  #?(:cljs (:require
            [common.dates :as dates]))
  #?(:clj (:require
           [common.dates :as dates])))

(def rfc-2822 "EEE, dd MMM yyyy HH:mm:ss zzz")

; If you add new date formats, please handle the validation in
; common.dates/valid-date-string? -function
(def formats
  ["d.M.yyyy"
   "dd.MM.yyyy"

   "d/M/yyyy"
   "dd/MM/yyyy"
   "M/d/yyyy"
   "MM/dd/yyyy"
   "yyyy/M/d"
   "yyyy/MM/dd"

   "yyyy-M-d"
   "yyyy-MM-dd"
   "dd-MMM-yy"

   "yyyy MMM d"
   "d MMM yyyy"
   "dd MMM yyyy"
   "MMM d yyyy"
  ])


(def choices
  (->> formats
       (map (fn [k]
              [k k]))))

(def options
  (->> formats
       (map (fn [k]
              {:key   k
               :label k}))))

(defn format-date
  [date fmt]
  (dates/format date {:format fmt}))

(defn format-millis
  [ms fmt tz]
  #?(:cljs (let [dt (-> ms
                        (js/Date.)
                        (dates/-to-date-time))]
             (try (dates/format dt
                                {:pattern  fmt
                                 :timezone tz})
                  (catch js/Object e
                    (js/console.log "Date format error : " e)
                    false)))
     :clj (-> ms
              (java.util.Date.)
              (dates/-to-date-time)
              (dates/format {:pattern  fmt
                             :timezone tz}))))
